import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
}
const getHeaders = () => ({
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
});

export function* getBitacoras(action) {
  try {
    const { payload } = action;
    let URLDestino = `api/bitacoras/${payload ? "?" + payload : ""}`;
    const metodo = "GET";
    const res = yield call(gaxios.request, {
      url: URLDestino,
      method: metodo,
      headers: getHeaders()
    });

    if (res.data.success) {
      yield put({
        type: actions.GET_BITACORAS_SUCCESS,
        payload: res.data.bitacoras,
      });
    } else {
      notification('error', res.data.msg);
    }
  } catch (err) {
    console.error('Error al obtener bitácoras:', err)
    const message =
      err.response?.data?.msg ||
      err.response?.data?.message ||
      err.message;

    notification('error', message);
  }
}

export function* getBitacoraById(action) {
  try {
    const { payload } = action;
    let URLDestino = `api/bitacoras/${payload}`;
    const metodo = "GET";
    const res = yield call(gaxios.request, {
      url: URLDestino,
      method: metodo,
      headers: getHeaders()
    });
    if (res.data.success) {
      yield put({
        type: actions.GET_BITACORA_BY_ID_SUCCESS,
        payload: res.data.bitacora,
      });
    } else {
      notification('error', res.data.msg);
    }
  } catch (err) {
    console.error('Error al obtener bitácora:', err)
    const message =
      err.response?.data?.msg ||
      err.response?.data?.message ||
      err.message;

    notification('error', message);
  }
}


export function* getReparacionesBitacora(action) {
  try {
    const { payload } = action;
    let URLDestino = `api/bitacoras/${payload}/reparaciones`;
    const metodo = "GET";
    const res = yield call(gaxios.request, {
      url: URLDestino,
      method: metodo,
      headers: getHeaders()
    });
    if (res.data.success) {
      yield put({
        type: actions.GET_REPARACIONES_SUCCESS,
        payload: res.data.reparaciones,
      });
    } else {
      notification('error', res.data.msg);
    }
  } catch (err) {
    console.error('Error al obtener bitácora:', err)
    const message =
      err.response?.data?.msg ||
      err.response?.data?.message ||
      err.message;

    notification('error', message);
  }
}


export function* createBitacora(action) {
  try {
    const { payload, history } = action;
    const res = yield call(gaxios.request, {
      url: `api/bitacoras`,
      method: 'POST',
      data: payload,
      headers: getHeaders()
    });
    console.log(res)
    if (!res.data.success) {
      notification('error', res.data.msg);
    } else {
      notification('success', 'Bitácora creada con éxito');
      yield put({
        type: actions.GET_BITACORAS_REQUEST,
      });
      if (history) {
        history.push('/dashboard/bitacoras');
      }
    }
  } catch (err) {
    const message =
      err.response?.data?.msg ||
      err.response?.data?.message ||
      err.message;

    notification('error', message);
  }
}

export function* updateBitacora(action) {
  try {
    const { id, payload } = action;

    const res = yield call(gaxios.request, {
      url: `api/bitacoras/${id}`,
      method: 'PUT',
      data: payload,
      headers: getHeaders()
    });
    if (!res.data.success) {
      notification('error', res.data.msg);
    } else {
      notification('success', 'Bitácora actualizada con éxito');
      yield put({
        type: actions.GET_BITACORAS_REQUEST,
      });
      yield put({
        type: actions.GET_BITACORA_BY_ID_REQUEST,
        payload: id,
      });
    }
  } catch (err) {
    const message =
      err.response?.data?.msg ||
      err.response?.data?.message ||
      err.message;
    notification('error', message);
  }
}

//export function* deleteBitacora(action) {
//   try {
//     const { payload } = action;

//     const res = yield call(gaxios.request, {
//       url: `api/bitacoras/${payload}`,
//       method: 'DELETE',
//       headers: getHeaders(),
//     });

//     if (!res.data.success) {
//       notification('error', res.data.msg);
//     } else {
//       notification('success', 'Bitácora eliminada con éxito');
//       yield put({
//         type: actions.DELETE_BITACORA_SUCCESS,
//         payload: res.data,
//       });
//     }
//   } catch (err) {
//     const message =
//       err.response?.data?.msg ||
//       err.response?.data?.message ||
//       err.message;
//     notification('error', message);
//   }
// }


export default function* rootSaga() {
  yield all([
    takeLatest(actions.GET_BITACORAS_REQUEST, getBitacoras),
    takeLatest(actions.GET_BITACORA_BY_ID_REQUEST, getBitacoraById),
    takeLatest(actions.CREATE_BITACORA_REQUEST, createBitacora),
    takeLatest(actions.UPDATE_BITACORA_REQUEST, updateBitacora),
    takeLatest(actions.GET_REPARACIONES_REQUEST, getReparacionesBitacora),
    // yield takeLatest(actions.DELETE_BITACORA_REQUEST, deleteBitacora),
  ]);
}
